import { StatisticsVariableId } from '../../../core/src/shared/statistics-config';

export type ChartDataVariableId = StatisticsVariableId;

export const defaultYAxisDomainEndFrom: ChartDataVariableId[] = [
  'PV_POWER_GRAPH',
  'PV_BATTERY_CHARGE_GRAPH',
  'PV_BATTERY_DISCHARGE_GRAPH',
  'HW_POWER_GRAPH',
  'HP_CONSUMED_GRAPH',
  'EM_CONSUMED_GRAPH',
  'EM_OVERFLOW_GRAPH',
  'PL_POWER_GRAPH',
  'HOME_CONSUMPTION',
];
